import type { Client, RequestContext } from "../client";
import type { GetArgoCDInstanceSummariesResponse } from "../resources/index";
type ListArgoCDInstanceSummariesArgs = {
    name: string;
    partialName: string;
    environmentIds: string[];
};
export class ArgoCDInstancesRepository {
    protected client: Client;
    baseUrl = "~/api/spaces/{spaceId}/argocdinstances";
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    list(args?: Partial<ListArgoCDInstanceSummariesArgs>): Promise<GetArgoCDInstanceSummariesResponse> {
        return this.client.get<GetArgoCDInstanceSummariesResponse>(this.requestContext, `${this.baseUrl}/summaries{?name,partialName,environmentIds*}`, args);
    }
}
